/**
 * VeriWine REST API
 * Defintion of VeriWine REST API
 *
 * OpenAPI spec version: 0.1.1
 * Contact: info@short.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpResponse, HttpHeaders} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {SERVER_URL} from './server-url';
import {ApiUtilsService} from './api-utils.service'
import {
    FileTransferDto,
    ImageInfoDto,
    PageVineyardDto,
    VineyardDto
} from '../domain';


@Injectable({
    providedIn: 'root'
})
export class VineyardControllerService {

    constructor(
        @Inject(SERVER_URL) private _serverUrl: string,
        private _httpClient: HttpClient,
        private _apiUtils: ApiUtilsService
    ) {
    }

    private _headers: HttpHeaders = undefined;

    addCustomHeader(headerName: string, headerValue: string | string[]): this {
        if (!this._headers) {
            this._headers = new HttpHeaders();
        }
        this._headers = this._headers.append(headerName, headerValue);
        return this;
    }


        addVineyardImage(
                    id: string
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
                    , 
                    
                    requestBody: FileTransferDto
    ): Observable<string> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/vineyard/${id}/image`;

            return this._httpClient.post<string>(url, requestBody, requestOptions);
    }


        createVineyard(
                
                queryParams: {
                    userLegalEntityId?: number
                }
                    
                    , 
                    requestBody: VineyardDto
    ): Observable<string> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/vineyard`;

            return this._httpClient.post<string>(url, requestBody, requestOptions);
    }


        getGrapeVarietiesForVineyard(
                
                queryParams: {
                    wineryId?: number,
                    vineyardIds?: Array<number>
                }
    ): Observable<Array<string>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/vineyard/grapeVarieties`;

            return this._httpClient.get<Array<string>>(url, requestOptions);
    }


        getVineyard(
                    id: string
    ): Observable<VineyardDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/vineyard/${id}`;

            return this._httpClient.get<VineyardDto>(url, requestOptions);
    }


        getVineyardImage(
                    id: string,
                    imageId: string
    ): Observable<Array<string>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/vineyard/${id}/images/${imageId}`;

            return this._httpClient.get<Array<string>>(url, requestOptions);
    }


        getVineyardImagesInfos(
                    id: string
    ): Observable<Array<ImageInfoDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/vineyard/${id}/images`;

            return this._httpClient.get<Array<ImageInfoDto>>(url, requestOptions);
    }


        getVineyardInfoPage(
                
                queryParams: {
                    ids?: Array<string>,
                    ownerId?: number,
                    name?: string,
                    userLegalEntityId?: number,
                    page?: number,
                    size?: number,
                    sort?: Array<string>
                }
    ): Observable<PageVineyardDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/vineyard/page`;

            return this._httpClient.get<PageVineyardDto>(url, requestOptions);
    }


        getVineyardsSearchPage(
                
                queryParams: {
                    ownerId?: number,
                    userLegalEntityId?: number
                }
    ): Observable<Array<VineyardDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/vineyard/all`;

            return this._httpClient.get<Array<VineyardDto>>(url, requestOptions);
    }


        removeVineyard(
                    id: string
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/vineyard/${id}`;

            return this._httpClient.delete<boolean>(url, requestOptions);
    }


        removeVineyardImage(
                    id: string,
                    imageId: string
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/vineyard/${id}/images/${imageId}`;

            return this._httpClient.delete<boolean>(url, requestOptions);
    }


        updateVineyard(
                
                queryParams: {
                    userLegalEntityId?: number
                }
                    
                    , 
                    requestBody: VineyardDto
    ): Observable<string> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/vineyard`;

            return this._httpClient.put<string>(url, requestBody, requestOptions);
    }


}

